import {
  MyAccountMiniThemeProvider,
  usePlatformConfig,
  useSalesEnablementCommunication,
} from '@dxp-module/common'
import MiniWidgetContent from './MiniWidgetContent'

const MiniMyAccountWidget = () => {
  const { platformConfig } = usePlatformConfig()
  const { isInSalesEnablement } = useSalesEnablementCommunication()

  if (isInSalesEnablement) {
    return null
  }

  return (
    <MyAccountMiniThemeProvider themeOverride={platformConfig.themeOverride}>
      <MiniWidgetContent />
    </MyAccountMiniThemeProvider>
  )
}

export default MiniMyAccountWidget
